import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';

export default function PrivacyPolicy() {
  return (
    <div className="page-wrapper" style={{ paddingTop: '80px' }}>
      <SEOHead
        title="Privacy Policy — Redcubical Systems"
        description="Privacy Policy for Redcubical Systems products including HealHub, Suraksha, and Vedant. DPDP Act 2023 compliant."
        canonical="/privacy-policy"
      />

      <section style={{
        padding: '80px 32px 120px',
        background: 'var(--black)',
        minHeight: '100vh',
      }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>

          {/* Header */}
          <div style={{ marginBottom: '56px' }}>
            <span className="section-label" style={{ marginBottom: '16px' }}>
              Legal
            </span>
            <h1 style={{
              fontFamily: 'Barlow Condensed, sans-serif',
              fontSize: 'clamp(36px, 6vw, 64px)',
              fontWeight: '900', color: '#fff',
              textTransform: 'uppercase',
              lineHeight: 1.05, marginBottom: '16px',
            }}>
              PRIVACY POLICY
            </h1>
            <p style={{
              fontSize: '14px',
              color: 'rgba(255,255,255,0.35)',
            }}>
              Last updated: February 2026 ·
              Effective for all Redcubical Systems products
            </p>
          </div>

          {/* Content */}
          <div style={{
            display: 'flex', flexDirection: 'column', gap: '40px',
          }}>
            {[
              {
                title: '1. Who We Are',
                content: `Redcubical Systems Private Limited ("Redcubical", "we", "us", or "our") is a software company incorporated in Dehradun, Uttarakhand, India. We build and operate software products including HealHub (clinic management software), Suraksha (anti-fraud mobile application), Vedant (AI receptionist), and HealHub Nexus (professional network for doctors).

Our registered address is: Dev Heights, First Floor, Aman Vihar, Sahastradhara Road, Dehradun — 248001, Uttarakhand, India.`,
              },
              {
                title: '2. Data We Collect',
                content: `We collect only the data necessary to provide our services:

Contact Information: Name, email address, phone number, and organisation name when you fill in any form on our website or products.

Usage Data: Pages visited, features used, and interaction patterns — collected anonymously to improve our products.

Healthcare Data (HealHub only): Patient records, appointment data, prescription information, and billing data — collected and processed only on behalf of the clinic operating HealHub. This data is never used for any purpose other than operating the clinic's software.

Device Data: Device type, browser, and IP address for security and fraud prevention purposes.`,
              },
              {
                title: '3. How We Use Your Data',
                content: `We use your data exclusively to:

— Provide and operate our software products and services
— Respond to your enquiries and support requests
— Send product updates and launch notifications (only if you have opted in)
— Improve our products based on usage patterns
— Comply with legal obligations under Indian law

We do not use your data for advertising, profiling, or any purpose not listed above.`,
              },
              {
                title: '4. Data We Never Collect or Share',
                content: `We make the following absolute commitments:

— We never sell your personal data to any third party
— We never share your data with advertisers or marketing platforms
— We never store call recordings (Suraksha processes calls in real time only)
— We never share healthcare data with insurance companies, pharmaceutical companies, or any third party without explicit consent
— We do not use your data for AI training without explicit opt-in consent`,
              },
              {
                title: '5. Data Storage & Security',
                content: `All data is stored on servers located in India (Mumbai region) in compliance with the Digital Personal Data Protection Act 2023 (DPDP Act).

Security measures in place:
— AES-256 encryption for all data at rest
— TLS 1.3 for all data in transit
— Role-based access control — only authorised personnel access data
— Regular security audits and vulnerability assessments
— No sensitive data stored in unencrypted local storage`,
              },
              {
                title: '6. Your Rights Under the DPDP Act 2023',
                content: `As a data principal under India's Digital Personal Data Protection Act 2023, you have the following rights:

Right to Access: Request a copy of all personal data we hold about you.

Right to Correction: Request correction of inaccurate or incomplete data.

Right to Erasure: Request deletion of all your personal data from our systems.

Right to Grievance: Raise a complaint with our Grievance Officer.

To exercise any of these rights, contact our Grievance Officer at: a.uniyal@redcubicalsystems.com`,
              },
              {
                title: '7. Cookies',
                content: `Our website uses minimal cookies:

Essential Cookies: Required for the website to function. Cannot be disabled.

Analytics Cookies: Used to understand how visitors use our website. No personally identifiable information is collected. You may opt out at any time.

We do not use advertising cookies or cross-site tracking cookies.`,
              },
              {
                title: '8. Third-Party Services',
                content: `We use the following third-party services to operate our products:

— Firebase (Google): Authentication and database services. Data processed under Google's privacy policy.
— EmailJS: For processing contact form submissions. No data is stored by EmailJS beyond transmission.
— OpenAI: Powers the AI capabilities in Vedant. Data sent to OpenAI is processed under OpenAI's data processing agreement.

We ensure all third-party providers are contractually bound to appropriate data protection standards.`,
              },
              {
                title: '9. Children\'s Privacy',
                content: `Our products are not directed at children under the age of 18. We do not knowingly collect personal data from children. If you believe a child has provided us with personal data, please contact us immediately and we will delete it.`,
              },
              {
                title: '10. Changes to This Policy',
                content: `We may update this Privacy Policy from time to time. We will notify you of significant changes by email (if you are a registered user) or by posting a prominent notice on our website. The date at the top of this page reflects when the policy was last updated.`,
              },
              {
                title: '11. Grievance Officer',
                content: `In accordance with the Digital Personal Data Protection Act 2023 and the Information Technology Act 2000, the details of our Grievance Officer are:

Name: Ashish Uniyal
Designation: Founder & Grievance Officer
Company: Redcubical Systems Private Limited
Address: Dev Heights, First Floor, Aman Vihar, Sahastradhara Road, Dehradun — 248001
Email: a.uniyal@redcubicalsystems.com
Phone: +91 9368487416

We will respond to all grievances within 30 days of receipt.`,
              },
              {
                title: '12. Contact Us',
                content: `For any privacy-related questions or requests:

Email: a.uniyal@redcubicalsystems.com
Phone: +91 9368487416
Address: Dev Heights, First Floor, Aman Vihar, Sahastradhara Road, Dehradun — 248001, Uttarakhand, India`,
              },
            ].map((section, i) => (
              <div key={i} style={{
                paddingBottom: '40px',
                borderBottom: '1px solid rgba(255,255,255,0.06)',
              }}>
                <h2 style={{
                  fontFamily: 'Barlow Condensed, sans-serif',
                  fontSize: '22px', fontWeight: '900',
                  color: '#fff', textTransform: 'uppercase',
                  marginBottom: '16px',
                }}>
                  {section.title}
                </h2>
                <div style={{
                  fontSize: '15px',
                  color: 'rgba(255,255,255,0.55)',
                  lineHeight: '1.85',
                  whiteSpace: 'pre-line',
                }}>
                  {section.content}
                </div>
              </div>
            ))}
          </div>

          {/* Back link */}
          <div style={{ marginTop: '64px', display: 'flex', gap: '16px' }}>
            <Link to="/" className="btn-outline"
              style={{ padding: '12px 24px', fontSize: '13px' }}>
              ← Back to Home
            </Link>
            <Link to="/contact" className="btn-blue"
              style={{ padding: '12px 24px', fontSize: '13px' }}>
              Contact Us →
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}